/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/sv-circle': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: `
      <g clip-path="url(#clip0_57_14057)">
      <mask id="mask0_57_14057" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="60" height="61">
      <path d="M59.9985 -0.000335693H0.000976562V59.9972H59.9985V-0.000335693Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_57_14057)">
      <path d="M15.8089 0.035675H-14.1902V24.0349H15.8089V0.035675Z" fill="#004073"/>
      <path d="M15.8089 35.9969H-14.1902V59.9962H15.8089V35.9969Z" fill="#003F73"/>
      <path d="M15.8089 24.0212H-14.1902V36.0209H15.8089V24.0212Z" fill="#FFCC00"/>
      <path d="M27.6852 0.00140381H15.6855V59.9995H27.6852V0.00140381Z" fill="#FFCC00"/>
      <path d="M81.3027 24.0247H27.3044V36.0243H81.3027V24.0247Z" fill="#FFCC00"/>
      <path d="M81.6731 36.0003H27.6748V59.9996H81.6731V36.0003Z" fill="#003F73"/>
      <path d="M81.6731 0.035675H27.6748V24.0349H81.6731V0.035675Z" fill="#003F73"/>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_57_14057">
      <rect width="60" height="60" rx="30" fill="white"/>
      </clipPath>
      </defs>
    `
  }
})
